import { createAction } from 'redux-actions'
import * as constants from './constants'

export const fetchOverview = createAction(constants.FETCH_OVERVIEW)
export const fetchOverviewPending = createAction(constants.FETCH_OVERVIEW_PENDING)
export const fetchOverviewFailed = createAction(constants.FETCH_OVERVIEW_FAILED)
export const receiveOverview = createAction(constants.RECEIVE_OVERVIEW)



// WEBPACK FOOTER //
// ./src/scripts/app/modules/org/overview/actions.js